@let totalOptionsCount = store.totalOptionsCount() || 0;
@let useSearch = totalOptionsCount > DEFAULT_VISIBLE_OPTIONS_COUNT; @let searchEnabled = store.searchEnabled(); @if
(field(); as f) {
<content [requestStatus]="store.optionsCallStatus()">
  @if(!totalOptionsCount) { No options found }
  @else {
  <div class="header">
    <div class="panel"
         [style.text-align]="'right'">
      @if(useSearch) {
      <kt-generic-button appearance="icon"
                         tooltipMessage="Enable Search"
                         (click)="store.toggleSearchBar()">
        {{ searchEnabled ? 'search_off' : 'search' }}
      </kt-generic-button>
      } @if(!store.everySelected()) {
      <kt-generic-button appearance="icon"
                         [tooltipMessage]="'Select All'"
                         (click)="store.toggleAllOptions(true)">select_all</kt-generic-button>
      } @if(store.someSelected()) {
      <kt-generic-button appearance="icon"
                         [tooltipMessage]="'Invert Selection'"
                         (click)="store.toggleAllOptions()">flip</kt-generic-button>
      } @if(store.someSelected() || store.everySelected()) {
      <kt-generic-button appearance="icon"
                         [tooltipMessage]="'Deselect All'"
                         (click)="store.toggleAllOptions(false)">deselect</kt-generic-button>
      }
    </div>

    <div class="search">
      @if(searchEnabled) {
      <mat-form-field subscriptSizing="dynamic"
                      [style.width.%]="100">
        <mat-label>Search</mat-label>
        <input matInput
               type="text"
               [ngModel]="store.search()"
               (ngModelChange)="store.searchOptions($event)"
               cdkTrapFocus
               [cdkTrapFocusAutoCapture]="true" />
        <button *ngIf="store.search()"
                matSuffix
                mat-icon-button
                aria-label="Clear"
                (click)="store.searchOptions('')">
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>
      }
    </div>
  </div>

  @let cols = f.props?.['cols'] ?? store.columns();

  <div class="grid-row"
       [style.gap.px]="f.props?.['gap'] ?? 16">
    @for (opt of store.visibleOptions(); track opt?.value) {
    <mat-checkbox [class]="'grid-col-' + cols"
                  class="checkbox"
                  [indeterminate]="false"
                  [checked]="opt?.active ?? false"
                  [disabled]="f.props?.['disabled']"
                  (change)="store.toggleOption(opt.value)">
      <span>{{ opt?.label }}</span>
    </mat-checkbox>
    }
  </div>

  @if(store.hasMoreOptions()) {
  <div class="panel"
       [style.text-align]="'center'">
    <kt-generic-button appearance="stroked"
                       (click)="store.showMoreOptions()">Show more</kt-generic-button>
  </div>
  } @else if (store.visibleOptionsCount() > store.initialVisibleOptionsCount()) {
  <div class="panel"
       [style.text-align]="'center'">
    <kt-generic-button appearance="stroked"
                       (click)="store.showLessOptions()">Show less</kt-generic-button>
  </div>
  }
  }
</content>
}